export const clones = {
	types: [
		{
			name: ''
		}
	],
	subjects: [
		{
			name: ''
		}
	],
	departments: [
		{
			name: ''
		}
	],
};


// WEBPACK FOOTER //
// ./src/reducers/settings/clones.js